import React from 'react';

import { CustomPaper } from '@/components/shared/components/CustomPaper';
import { LoadingFill } from '@/components/shared/components/LoadingFill';

interface ArticleTypeDetailsFormWrapperProps {
  loadingDetailsForm?: boolean;
  children: React.ReactNode;
}

export const ArticleTypeDetailsFormWrapper = ({ loadingDetailsForm, children }: ArticleTypeDetailsFormWrapperProps) => {
  return (
    <CustomPaper
      style={{
        boxShadow: 'none',
        padding: '15px 0 25px',
      }}
    >
      {children}
      {loadingDetailsForm !== undefined && <LoadingFill open={loadingDetailsForm} hideProgress />}
    </CustomPaper>
  );
};
